import { render, staticRenderFns } from "./QuizSubmissionsTable.vue?vue&type=template&id=5e44cddb&scoped=true&"
import script from "./QuizSubmissionsTable.vue?vue&type=script&lang=ts&"
export * from "./QuizSubmissionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./QuizSubmissionsTable.vue?vue&type=style&index=0&id=5e44cddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e44cddb",
  null
  
)

export default component.exports